var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99984 0.333374C8.2065 0.333374 9.99984 2.10671 9.99984 4.30004C9.99984 7.27337 5.99984 11.6667 5.99984 11.6667C5.99984 11.6667 1.99984 7.27337 1.99984 4.30004C1.99984 2.10671 3.79317 0.333374 5.99984 0.333374ZM5.99984 3.00004C5.64621 3.00004 5.30708 3.14052 5.05703 3.39056C4.80698 3.64061 4.6665 3.97975 4.6665 4.33337C4.6665 4.687 4.80698 5.02613 5.05703 5.27618C5.30708 5.52623 5.64621 5.66671 5.99984 5.66671C6.35346 5.66671 6.6926 5.52623 6.94265 5.27618C7.19269 5.02613 7.33317 4.687 7.33317 4.33337C7.33317 3.97975 7.19269 3.64061 6.94265 3.39056C6.6926 3.14052 6.35346 3.00004 5.99984 3.00004ZM11.3332 11.6667C11.3332 13.14 8.9465 14.3334 5.99984 14.3334C3.05317 14.3334 0.666504 13.14 0.666504 11.6667C0.666504 10.8067 1.47984 10.04 2.73984 9.55337L3.1665 10.16C2.4465 10.46 1.99984 10.8734 1.99984 11.3334C1.99984 12.2534 3.79317 13 5.99984 13C8.2065 13 9.99984 12.2534 9.99984 11.3334C9.99984 10.8734 9.55317 10.46 8.83317 10.16L9.25984 9.55337C10.5198 10.04 11.3332 10.8067 11.3332 11.6667Z",
    fill: "#A5AEB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.7e408bd8ba8ae247eabce2735a4287ca.svg";
export { ForwardRef as ReactComponent };